import {
  Box,
  Divider,
  Group,
  SegmentedControl,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import NavbarToggler from "../../../../components/View/NavbarToggler";
import { useEffect, useMemo, useState } from "react";
import { useUIStore } from "../../../../stores/UIStore";
import LeftWrapperContacts from "./contacts/LeftWrapperContacts";
import RightWrapperContacts from "./contacts/RightWrapperContacts";
import LeftWrapperBlacklists from "./blacklists/LeftWrapperBlacklists";
import RightWrapperBlacklist from "./blacklists/RightWrapperBlacklist";
import LeftWrapperUnsubs from "./unsubscribers/LeftWrapperUnsubs";
import RightWrapperUnsubs from "./unsubscribers/RightWrapperUnsubs";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";
import Notifications from "../../../../layouts/Header/Notifications";
import HeaderProfile from "../../../../layouts/Header/HeaderProfile";
import AllSwitcher from "../../../../layouts/Footer/AllSwitcher";
import { useProfileStore, useSessionStore } from "../../../../stores/UserStore";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { IconGripVertical } from "@tabler/icons-react";

const ListingWithContent = ({ type = "/contact-lists" }) => {
  const lang = useLanguage((s) => s.language);
  const unswitchedProfile = useProfileStore((s) => s.unswitchedProfile);
  const profile = useProfileStore((s) => s.profile);
  const user_switch = useSessionStore((s) => s.user_switch);

  useEffect(() => {
    useUIStore.getState().setHeaderClosed(true);

    return () => {
      useUIStore.getState().setHeaderClosed(false);
    };
  }, []);

  const sections = useMemo(() => {
    if (type === "/contact-lists") {
      return {
        left: <LeftWrapperContacts />,
        right: <RightWrapperContacts />,
      };
    }
    if (type === "/blacklists") {
      return {
        left: <LeftWrapperBlacklists />,
        right: <RightWrapperBlacklist />,
      };
    }
    if (type === "/unsubscribers") {
      return {
        left: <LeftWrapperUnsubs />,
        right: <RightWrapperUnsubs />,
      };
    }
  }, [type]);

  const canSwitch = useMemo(() => {
    let p = user_switch ? unswitchedProfile : profile;
    if (
      !p?.permissions?.find((x) => x.name === "switchOrganizationUser")
        ?.value &&
      !p?.permissions?.find((x) => x.name === "switchTeamUser")?.value &&
      p?.level === "user"
    ) {
      return false;
    }
    return true;
  }, [user_switch, unswitchedProfile, profile]);
  // const navigate = useNavigate();
  // const handleTypeChange = (v) => {
  //   navigate(v);
  // };

  return (
    <Stack gap={0} pos={"relative"} flex={1}>
      <Group justify="center" h={60} pr={16} bg={"#fff"}>
        <SegmentedControl
          value={type}
          // onChange={handleTypeChange}
          data={[
            {
              label: (
                <Text
                  component={Link}
                  to={"/contact-lists"}
                  fw={500}
                  fz={13}
                  display={"flex"}
                  py={8}
                  px={32}
                >
                  {lang.prospects.tabs.lists}
                </Text>
              ),
              value: "/contact-lists",
            },
            {
              label: (
                <Text
                  component={Link}
                  to={"/blacklists"}
                  fw={500}
                  fz={13}
                  display={"flex"}
                  py={8}
                  px={32}
                >
                  {lang.prospects.tabs.blacklists}
                </Text>
              ),
              value: "/blacklists",
            },
            {
              label: (
                <Text
                  component={Link}
                  to={"/unsubscribers"}
                  fw={500}
                  fz={13}
                  display={"flex"}
                  py={8}
                  px={32}
                >
                  {lang.prospects.tabs.unsubscribers}
                </Text>
              ),
              value: "/unsubscribers",
            },
          ]}
          size="sm"
          radius={"md"}
          styles={{
            root: {
              gap: 16,
            },
            label: {
              padding: 0,
            },
          }}
          bg={"var(--mantine-color-primary-2)"}
          mx={"auto"}
        />

        <Group>
          <Notifications />
        </Group>

        <Divider orientation="vertical" my={16} mx={"md"} opacity={0.75} />

        <HeaderProfile />

        {canSwitch && <AllSwitcher />}
      </Group>

      <Divider />

      <NavbarToggler pos="absolute" left={12} top={6} style={{ zIndex: 4 }} />

      <PanelGroup
        direction="horizontal"
        style={{ flex: 1 }}
        autoSaveId={
          type === "/contact-lists"
            ? "layout-drag-list"
            : type === "/blacklists"
            ? "layout-drag-blacklist"
            : "layout-drag-unsubscribers"
        }
      >
        <Panel
          defaultSize={35}
          minSize={10}
          style={{ display: "flex", flexDirection: "column", paddingLeft: 24 }}
          collapsible
        >
          {sections.left}
        </Panel>
        <PanelResizeHandle
          style={{
            width: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "col-resize",
            backgroundColor: "var(--mantine-color-primary-3)",
            margin: "0 24px",
          }}
        >
          <Box
            style={{
              backgroundColor: "var(--mantine-color-gray-2)",
              borderRadius: "4px",
              display: "flex",
            }}
          >
            <ThemeIcon variant="filled" py={16}>
              <IconGripVertical size={24} />
            </ThemeIcon>
          </Box>
        </PanelResizeHandle>
        <Panel minSize={20} collapsible>
          {sections.right}
        </Panel>
      </PanelGroup>
    </Stack>
  );
};

export default ListingWithContent;
